<template>
  <div class="car-male">
    <div>
      <span style="border-right:1px solid blue;" class="trend-title">车辆编号（车牌号）</span>
      <span style="border-right:1px solid blue;" class="trend-title">上月里程</span>
      <span class="trend-title">本月里程</span>
      <!-- <el-button @click="addCar" style="margin-left:1rem" type="primary" icon="el-icon-plus"></el-button> -->
      <i @click="addCar" class="el-icon el-icon-circle-plus-outline f_green" style="margin-top:10px"></i>
    </div>
    <div v-for="(item,index) in carDate" :key="index">
      <div class="car-males">
        <el-input show-word-limit type="text" maxlength="20" placeholder="请输入" v-model="item.carNum"></el-input>
        <el-input type="number" v-model="item.mileageLast">
          <template slot="suffix">Km</template>
        </el-input>
        <el-input type="number" v-model="item.mileage">
          <template slot="suffix">Km</template>
        </el-input>
        <!-- <el-button @click="removeCar(item.id,index)" style="margin-left:1rem" type="primary" icon="el-icon-minus"></el-button> -->
        <i @click="removeCar(item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="maleLoading" size="small" @click="saveMale" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/transportation/transportation'
export default {
  data(){
    return{
      maleLoading:false,//加载状态
      carDate:[
        {carNum:'',mileageLast:'',mileage:''}
      ]
    }

  },
  mounted(){
    this.getMale()
  },
  methods:{
    //保存数据
    saveMale(){
      this.maleLoading = true;
      api.saveCarMile(this.carDate).then(res=>{
        if(res.code==10000){
          this.maleLoading = false;
          this.getMale()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.maleLoading = false;
          return;
        }
      })
    },
    //获取数据
    getMale(){
      api.getCarMile().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.carDate = res.data.list
          }
        }
      })
    },
    //删除一行车辆
    removeCar(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delCarMile([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getMale()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.carDate.splice(index,1)
      }
    },
    //增加一行车辆
    addCar(){
      this.carDate.push({carNum:'',mileageLast:'',mileage:''})
    },
  }
}
</script>
<style lang="less" scoped>
.car-male{ padding-top: 10px;
  .trend-title{ text-align: center; width: 15rem;}
  .el-input{ width: 15rem;}
  i{ font-size: 1.2rem; font-weight: bold; margin-left: 1rem; vertical-align: middle;}
}
</style>